import { FC, ReactNode } from 'react';
import { DropdownProvider, SmartDebugGrid, ToastsProvider } from '@brg/ui';
import { Provider } from 'react-redux';
import { BAuth, AuthXProvider } from '@brg/auth';
import i18next from 'i18next';
import {ApplicationShared} from 'core';
import { createGlobalStyle } from "styled-components";
import { useToastsPosition } from "../hooks/useToastPosition";

type PropsT = {
  service: string;
  store: any;
  projectName: string;
  projectVersion: string;
  bgid: string;
  fip: string;

  applicationName: string;
  applicationContext: string;
}

const GlobalToastsStyle = createGlobalStyle`
  .react-toast-notifications__container {
    z-index: 2000001;
    bottom: 40px!important;

    @media(max-width: 1280px) {
      bottom: 50px!important;
    }

    @media(max-width: 940px) {
      bottom: 40px!important;
    }

    @media(max-width: 744px) {
      bottom: 28px!important;
    }

    @media(max-width: 568px) {
      bottom: 0px!important;
    }
    
    @media(max-width: 320px) {
      padding: 0 !important;
    }
  }
`

export const BCoreProvider: FC<PropsT & { children?: ReactNode }> = (props) => (
  // @ts-ignore
  <Provider store={props.store}>
    <AuthXProvider
      bgid={props.bgid}
      fip={props.fip}
      service={props.service}
      i18next={i18next}
      contextName={ApplicationShared.application}
      appName={ApplicationShared.application}
    >
      <GlobalToastsStyle/>
        <DropdownProvider>
          <ToastsProvider {...useToastsPosition('top-right')} >
            <SmartDebugGrid />
            <BAuth.OverlayMeta />
            {props.children}
          </ToastsProvider>
        </DropdownProvider>
    </AuthXProvider>
  </Provider>
);
import { FC, ReactNode } from 'react';
import { DropdownProvider, SmartDebugGrid, ToastsProvider } from '@brg/ui';
import { Provider } from 'react-redux';
import { BAuth, AuthXProvider } from '@brg/auth';
import i18next from 'i18next';
import {ApplicationShared} from 'core';
import { createGlobalStyle } from "styled-components";
import { useToastsPosition } from "../hooks/useToastPosition";

type PropsT = {
  service: string;
  store: any;
  projectName: string;
  projectVersion: string;
  bgid: string;
  fip: string;

  applicationName: string;
  applicationContext: string;
}

const GlobalToastsStyle = createGlobalStyle`
  .react-toast-notifications__container {
    z-index: 2000001;
    bottom: 40px!important;

    @media(max-width: 1280px) {
      bottom: 50px!important;
    }

    @media(max-width: 940px) {
      bottom: 40px!important;
    }

    @media(max-width: 744px) {
      bottom: 28px!important;
    }

    @media(max-width: 568px) {
      bottom: 0px!important;
    }
    
    @media(max-width: 320px) {
      padding: 0 !important;
    }
  }
`

export const BCoreProvider: FC<PropsT & { children?: ReactNode }> = (props) => (
  // @ts-ignore
  <Provider store={props.store}>
    <AuthXProvider
      bgid={props.bgid}
      fip={props.fip}
      service={props.service}
      i18next={i18next}
      contextName={ApplicationShared.application}
      appName={ApplicationShared.application}
    >
      <GlobalToastsStyle/>
        <DropdownProvider>
          <ToastsProvider {...useToastsPosition('top-right')} >
            <SmartDebugGrid />
            <BAuth.OverlayMeta />
            {props.children}
          </ToastsProvider>
        </DropdownProvider>
    </AuthXProvider>
  </Provider>
);
